module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{".PermissionManager":{"handleWom.upgradeOneclickSuccess.widget":[{"value":"@parent ~.SitePage_Join","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":".PermissionManager","_fox_":1}],"handleWom.upgradeOneclickSuccess.event":[{"value":"user_upgrage_oneclick","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":".PermissionManager","_fox_":1}],"handleWom.upgradeOneclickSuccess.callback":[{"value":function (params, performer) {
var app = performer.rwom1('@root');
var popup = app.embedWidget('memberOneclickUpgradeSuccess', 'Popup_Common', {
preventHideOnShadowClick: true,
'dialog.width': '300px',
'widgets.content': {
template: 'member_oneclick_upgrade'
}
});
popup.run();
return popup.show().wait('hide').then(function () {
popup.destroy();
});
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101021},"path":".PermissionManager","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/options/upgrade-success-action.opt
// module id = 821
// module chunks = 4